import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { colors, device } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './layout/StyledComponents';
import rectangle from '../images/svgs/rectangle.svg';
import girl from '../images/homepage.jpg';
import { css, cx } from '@emotion/css';
import mask from '../images/svgs/hero-mask.svg';

const StyledFAQ = styled.div`
    padding: 1em;

    .none {
        display: block;
        padding-bottom: 1em;
        opacity: 1;
        transition: 0.1s ease-in;
        p {
            z-index: 0;
        }
    }
    .first {
        transition: 0.2s ease-in;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: start;
        margin-top: 1.5em;
        height: 100%;
    }
    .hidden {
        p {
            visibility: hidden;
        }
        height: 0px;
        z-index: 2;
        opacity: 0;
    }
    .sub {
        font-size: 16px;
        margin-bottom: 1em;
    }
    .image {
        min-width: 22px;
    }
    .item {
        cursor: pointer;
        border-bottom: 2px solid ${colors.blue};
    }
    h6 {
        font-size: 20px;
        line-height: 32.6px;
        font-weight: 900;
        width: 100vw;
        margin: 1em 0em 0.75em;
    }
    button {
        margin-bottom: 0.75em;
    }
    @media ${device.tablet} {
        display: flex;
        width: 1250px;
        margin: 0 auto;
        justify-content: space-around;

        h6 {
            font-size: 20px;
            line-height: 38.6px;
            font-weight: 900;
            width: 100vw;
            margin: 1em 0em 0.75em;
        }
        h3 {
            padding-right: 4em;
            line-height: 54px;
            font-size: 48px;
            margin-bottom: 0.5em;
        }
        .second {
            max-width: 650px;
        }
    }
    @media ${device.laptop} {
        padding: 3em 0em;
    }
    @media ${device.desktop} {
        .image {
            min-width: 24px;
        }
        h3 {
            font-size: 50px;
        }
        h6 {
            font-size: 26px;
        }
        padding: 5em 0em;
    }
`;

type Question = {
    question: string;
    answer: string;
};

interface Props {
    questions: Question[];
}

export const FAQ: React.FC<Props> = ({ questions }) => {
    const [index, setIndex] = useState<number>();
    return (
        <StyledFAQ>
            <div className="section first">
                {questions && <h3>Frequently Asked Questions</h3>}
                <p className="sub">Have Questions About Preventive Dentistry? Find Answers Here.</p>
                <a rel="noopener noreferrer" href="tel:8132354143">
                    <Button color="blue">Call us for any question</Button>
                </a>
            </div>
            <div className="second section">
                <ul className="dropdown">
                    {questions &&
                        questions.map((question, i) => (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                            <div
                                key={question.question}
                                className="item"
                                onClick={() => {
                                    setIndex(index === i ? undefined : i);
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h6 className="question">{question.question}</h6>
                                    {index === i ? (
                                        <StaticImage
                                            placeholder="none"
                                            className="minus image"
                                            src="../images/svgs/minus-sign-black.svg"
                                            alt="minus sign"
                                        />
                                    ) : (
                                        <StaticImage
                                            placeholder="none"
                                            className="image"
                                            src="../images/svgs/plus-sign-black.svg"
                                            alt="plus sign"
                                        />
                                    )}
                                </div>
                                <div className={`${index === i ? 'none' : 'hidden'}`}>
                                    <p>{question.answer}</p>
                                </div>
                            </div>
                        ))}
                </ul>
            </div>
        </StyledFAQ>
    );
};
